import { ProgramForm, ProgramFormRef } from "@modules/programs/components/programForm"
import { ProgramSelectView } from "@modules/programs/components/programHeader/programSelectView"
import { ProgramInfoResume } from "@modules/programs/components/programInfoResume"
import { ProgramPriceForm, ProgramPriceFormRef } from "@modules/programs/components/programPriceForm"
import { ProgramSasPaymentChoices } from "@modules/programs/programSas/components/programSasPaymentChoices"
import { ProgramSasWarning } from "@modules/programs/programSas/components/programSasWarning"
import { Program, ProgramTypeOf } from "@modules/programs/programTypes"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { SidebarNavigatorParams } from "@modules/sidebar/sidebarTypes"
import { useRef } from "react"

export const useProgramSidebar = () => {
  const { sidebarNavigateTo } = useSidebar()
  const programFormRef = useRef<ProgramFormRef>(null)
  const programPriceFormRef = useRef<ProgramPriceFormRef>(null)

  const navigateToProgramView = (
    programId: string,
    programType: ProgramTypeOf,
    editionAllowed: boolean,
    args?: SidebarNavigatorParams,
  ) => {
    sidebarNavigateTo({
      content: <ProgramInfoResume programId={programId} programType={programType} editionAllowed={editionAllowed} />,
      replaceAllComponents: true,
      onHide: () => {
        return Promise.resolve(true)
      },
      ...args,
    })
  }

  const navigateToProgramCreationTypeSelection = () => {
    sidebarNavigateTo({
      content: <ProgramSelectView />,
      replaceAllComponents: true,
    })
  }

  const navigateToProgramCreation = (programType: ProgramTypeOf) => {
    sidebarNavigateTo({
      content: <ProgramForm programType={programType} ref={programFormRef} />,
      onHide: () => {
        return programFormRef && programFormRef.current ? programFormRef.current.onClose() : Promise.resolve(true)
      },
    })
  }

  const navigateToProgramEdition = (program: Program) => {
    sidebarNavigateTo({
      content: <ProgramForm program={program} programType={program._programType} ref={programFormRef} />,
      onHide: () => {
        return programFormRef && programFormRef.current ? programFormRef.current.onClose() : Promise.resolve(true)
      },
    })
  }

  const navigateToProgramPriceEdition = (program: Program, replaceLastComponent: boolean = false) => {
    sidebarNavigateTo({
      content: <ProgramPriceForm program={program} ref={programPriceFormRef} />,
      replaceLastComponent,
      onHide: () => {
        return programPriceFormRef && programPriceFormRef.current
          ? programPriceFormRef.current.onClose()
          : Promise.resolve(true)
      },
    })
  }

  const navigateToProgramPriceSasWarning = (program: Program) => {
    sidebarNavigateTo({
      content: <ProgramSasWarning program={program} />,
    })
  }

  const navigateToProgramSasPaymentChoices = (program: Program) => {
    sidebarNavigateTo({
      content: <ProgramSasPaymentChoices program={program} />,
      replaceLastComponent: true,
    })
  }

  return {
    navigateToProgramView,
    navigateToProgramCreationTypeSelection,
    navigateToProgramCreation,
    navigateToProgramEdition,
    navigateToProgramPriceEdition,
    navigateToProgramPriceSasWarning,
    navigateToProgramSasPaymentChoices,
  }
}
